import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IIconHelp {
  className?: string;
}

export const IconHelp: React.FC<IIconHelp> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 17 17"
    className={classNames(styles['root'], className)}
  >
    <path d="M8.4 0a8.5 8.5 0 10.2 17 8.5 8.5 0 00-.2-17zm0 13.7c-.8 0-1.3-.6-1.3-1.3 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.3c.1.7-.4 1.2-1.1 1.2zm3-6.1l-1 .9-.5.4-.6.6-.1.5v.1h-2v-.2c0-.7 0-1.1.3-1.4l1.6-1.1.3-.4.3-.7c0-.3-.1-.6-.3-.8-.1-.3-.4-.4-.9-.4s-.8.2-1 .5c-.2.3-.3.6-.3 1v.1h-2v-.1c.1-1.3.5-2.2 1.3-2.7a3 3 0 011.9-.6c1 0 1.8.2 2.5.7.7.5 1 1.2 1 2.1 0 .6-.2 1.1-.5 1.5z" />
  </svg>
);
